export default {
	fbID: '',
	univers: {
		x: 0,
		y: 0,
		scale: 1
	},
	states: {
		guide: '',
	},
	routeReferrerName: '',
	metaEvents: {
		lavetEtKoeb: 0,
		gangIOelTeltet: false
	},
	systemSettings: {
		oelteltYoutube: false,
		partytruckYoutube: false,
		esportTwitch: false
	},
	hasSeenWelcomeScreen: false,
	lastSentWuhuu: 0,
	showTshirtPopup: false
}
